<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body">
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.DEVICE_PAGE_VIEW' | translate }}</label>
      <mat-radio-group
        class="flex-col"
        [formControl]="devicePageNewViewControl"
      >
        <mat-radio-button [value]="true">
          {{ 'SUAS.ACCOUNT.DETAILS.NEW' | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="false">
          {{ 'SUAS.ACCOUNT.DETAILS.OLD' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      [disabled]="devicePageNewViewControl.invalid"
      [text]="'SUAS.COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
